$(document).ready(function () {
    $('.btn.btn-delete').on('click', function (_event) {
        var _element = $(this);
        if (_element.data('confirmRequired') === true) {
            _element.data('confirmRequired', false);
        } else {
            _event.preventDefault();
            bootbox.dialog({
                message: "Möchten Sie den Datensatz löschen?",
                title: "Löschen?",
                buttons: {
                    cancel: {
                        label: "Abbrechen",
                        className: "btn-default",
                        callback: function () {
                        }
                    },
                    confirm: {
                        label: "Ja",
                        className: "btn-danger",
                        callback: function () {
                            _element.data('confirmRequired', true);
                            _element.get(0).click();
                        }
                    }
                }
            });
        }
    });
});